<template>
  <div>
    <div
      v-if="!editMode"
    >
      <h1>
        Gestion des modèles de sélection d'articles
      </h1>
      <button @click="openEditor()">
        Créer un modèle
      </button>
      <div class="modeles">
        <span class="modeles__title">
          LISTE DES MODELES
        </span>
        <div v-if="Object.keys(modeles).length">
          <ul class="regroupements__list">
            <li
              v-for="(modele, id) of modeles"
              :key="id"
              class="modeles__list__item"
              @click="openEditor(modele.id)"
            >
              {{ modele.nom }}
            </li>
          </ul>
          <Pagination
            v-if="modelesPages > 1"
            :current="modelesPage"
            :pages="modelesPages"
            @change="setModelesPage"
          />
        </div>
        <span
          v-else
          class="empty"
        >
          Aucun modèle
        </span>
      </div>
    </div>
    <div v-else>
      <TheSelectionModeleEditor
        @close="closeEditor"
      />
    </div>
  </div>
</template>

<script>
import Pagination from './Pagination.vue'
import { mapGetters, mapActions } from 'vuex'
import TheSelectionModeleEditor from './TheSelectionModeleEditor'

export default {
  data() {
    return {
      editMode: false
    }
  },
  components: { TheSelectionModeleEditor, Pagination },
  computed: {
    ...mapGetters([
      'modeles',
      'modelesPages',
      'modelesPage'
    ])
  },
  created() {
    this.$store.dispatch('setModeles')
  },
  methods: {
    ...mapActions([
      'openEditorSelectionModele',
      'setModelesPage'
    ]),
    openEditor(id = null) {
      this.openEditorSelectionModele(id)
      this.editMode = true
    },
    closeEditor() {
      this.editMode = false
    }

  }
}
</script>

<style scoped>
.modeles__wrapper {
  display: inline-flex;
  flex-direction: column;
}

.modeles {
  display: flex;
  flex-direction: column;
}

.modeles__title {
  margin-top: 2em;
  margin-bottom: 1em;
  font-weight: bold;
}

.modeles__list {
  cursor: default;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  list-style-type: none;
  min-height: 18rem;
}

.modeles__list__item {
  cursor: pointer;
}

.empty {
  color: #616161;
}
</style>
